// About.js
import React from 'react';

const questionsAndAnswers = [
  ['What is a no-coding token generator DApp?', 'A no-coding token generator DApp is a decentralized application that allows users to create their own tokens without needing to write any code.<br />The DApp handles all the technical aspects of token creation, making it accessible to non-technical users.'],
  ['How do I use the token generator?', 'To use the token generator, you simply need to input the parameters for your token, such as its name, symbol, and total supply.<br />The DApp will then generate the token for you.'],
  ['What is a token?', 'In the context of blockchain and cryptocurrency, a token is a digital asset that is built on top of another blockchain. Tokens can represent a wide range of digital assets and values.'],
  ['What is a DApp?', 'DApp stands for decentralized application. Unlike traditional apps, DApps run on blockchain technology, which makes them transparent, open-source, and free from central control.'],
  ['What is blockchain?', 'Blockchain is a type of distributed ledger technology that stores data across multiple computers. This makes it highly secure and resistant to modification.'],
  ['What is cryptocurrency?', 'Cryptocurrency is a type of digital or virtual currency that uses cryptography for security. The most well-known cryptocurrency is Bitcoin.'],
  ['What is Ethereum?', 'Ethereum is an open-source, blockchain-based platform that enables developers to build and deploy decentralized applications (DApps).'],
  ['What is a smart contract?', 'A smart contract is a self-executing contract with the terms of the agreement directly written into code. They run on the blockchain, so they are stored publicly and can\'t be changed.'],
  ['What is DeFi?', 'DeFi stands for decentralized finance. It is a term used to describe financial applications that are built on top of blockchain technologies, particularly Ethereum.'],
  ['What is gas?', 'Gas refers to the fee required to successfully conduct a transaction or execute a contract on the Ethereum blockchain platform.']
];

function About() {
  return (
    <div className="about-container">
      {questionsAndAnswers.map((qa, index) => (
        <div key={index} style={{ marginBottom: '20px' }}>
          <p style={{ fontSize: '22px', fontWeight: 'bold' }}>{qa[0]}</p>
          <p style={{ fontSize: '22px' }} dangerouslySetInnerHTML={{ __html: qa[1] }}></p>
        </div>
      ))}
    </div>
  );
}

export default About;
